import { createRouterSelector } from '@townsquare/router/createRouterSelector';

import { useNoOrgExperience } from '@townsquare/org-context';
import { HomepageRoute } from '@townsquare/router/route-types';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute = createRouterSelector<HomepageRoute>(o => o.route as HomepageRoute);

export const useProjectsRoutes = () => {
	const noOrgExperience = useNoOrgExperience();
	const noWorkspaceExperience = useNoWorkspaceExperience();

	if (noOrgExperience || noWorkspaceExperience) {
		return noWorkspaceRoutes;
	}

	return routes;
};
